import { Select, SelectProps } from 'antd';
import React, { memo } from 'react';

import { L } from '@lib';

const { Option } = Select;

export const FuelTypeSelect: React.FC<SelectProps> = memo((props) => (
  <Select
    allowClear
    showSearch
    placeholder={L('Select fuel type')}
    style={{ width: '100%' }}
    {...props}
  >
    <Option value="Petrol">{L('Petrol')}</Option>
    <Option value="Diesel">{L('Diesel')}</Option>
    <Option value="Hybrid">{L('Hybrid')}</Option>
    <Option value="Plug-in Hybrid">{L('Plug-in Hybrid')}</Option>
    <Option value="Electric">{L('Electric')}</Option>
    <Option value="LPG">{L('LPG')}</Option>
    <Option value="CNG">{L('CNG')}</Option>
    <Option value="Hydrogen">{L('Hydrogen')}</Option>
    <Option value="Other">{L('Other')}</Option>
  </Select>
));
